module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate1.b993e6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate1.png
// module id = 744
// module chunks = 0